import moment from 'moment'
export default {
  state: {
    // 服务器时间(毫秒时间戳)，页面中所有需要用到当前时间的，都必须使用此时间戳
    timestamp: null
  },
  mutations: {
    setTimestamp: function (state, timestamp) {
      if (timestamp) {
        state.timestamp = moment(timestamp).valueOf()
      } else {
        state.timestamp = new Date().getTime()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js